exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px) {\n.vdp-datepicker.fullscreen-when-on-mobile {\n    position: static;\n}\n.vdp-datepicker.fullscreen-when-on-mobile .vdp-datepicker__calendar {\n    position: fixed;\n    top: 50%;\n    left: 5%;\n    margin-top: -25%;\n    width: 90%;\n    z-index: 2000;\n    outline: rgba(0, 0, 0, .5) solid 9999px;\n}\n}\n.pm-behavior-checkbox {\n  width: 1.3rem;\n  height: 1.3rem;\n}\n.cell.today {\n  background-color: rgb(220, 245, 252);\n}\n", ""]);

// exports
